import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import Swal from "sweetalert2";

const RenderStatusJobCard = ({ clinicianStatus, offerStatus, hiringType, checkStatus,  disable = false }) => {
    console.log(disable,"disablee")
    const handleStatusChange = (status) => {
        Swal.fire({
            text: `Do you want to accept the job and hire to facility?`,
            icon: 'question',
            showDenyButton: true, // This adds the 'No' button
            showCancelButton: true, // This adds the 'Close' button
            confirmButtonText: 'Accept', // The text for the 'Yes' button
            denyButtonText: 'Reject', // The text for the 'No' button
            cancelButtonText: 'Close', // The text for the 'Close' button
        }).then((result) => {
            if (result.isConfirmed) {
                // Logic for Yes button
                checkStatus(status);
            } else if (result.isDenied) {
                // Logic for No button
                checkStatus("Declined");
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Logic for Close button
                console.log('Close button clicked');
            }
        });

        // Swal.fire({
        //     text: `Do you want to accept the job and hire to facility ?`,
        //     icon: 'question',
        //     showCancelButton: true,
        //     confirmButtonText: 'Yes',
        //     cancelButtonText: 'No',
        // }).then((result) => {
        //     if (result.isConfirmed) {
        //         checkStatus(status);
        //     }
        // });
    };
    const renderContent = () => {
        if (hiringType !== "Self Hire" && clinicianStatus === "Pending") {
            return (
                <Box sx={{ display: "flex", gap: "8px" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => { handleStatusChange("Accepted"); }}>
                        Accept Job
                    </Button>
                    {/* <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => { handleStatusChange("Declined"); }}>
                        Reject Job
                    </Button> */}
                </Box>

            )
        }
        if ((clinicianStatus === "" || clinicianStatus === undefined) && offerStatus === "No Offer" && hiringType === "Self Hire") {
const shouldDisable =
  Array.isArray(disable) &&
  disable.some(
    (doc) =>
      doc.IS_REQUIRED === true &&
      (!doc.miscellaneous_Document || doc.miscellaneous_Document.length === 0)
  );
           
            return (
                <Button
                    variant="contained"
                    sx={{ backgroundColor: "#6ebe44" }}
                    type="submit"
                          disabled={shouldDisable} // 🔹 disable button if any required doc is missing
                    onClick={() => {
                        checkStatus("Interested");
                    }}>
                    I'm interested/ Apply
                </Button>
            )
        }
        if (clinicianStatus === "Interested") {
            return (

                <Grid className="dflex">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 48 48"
                    >
                        <circle cx="24" cy="24" r="20" fill="#3ddab4"></circle>
                        <polygon
                            fill="#c1f5ea"
                            points="39.091,17.515 35.015,13.604 22.775,26.233 16.679,20.433 12.768,24.509 18.843,30.289 22.92,34.179 26.86,30.119"
                        ></polygon>
                        <polygon
                            fill="#fff"
                            points="22.926,34.173 26.86,30.119 22.775,26.233 18.843,30.289"
                        ></polygon>
                    </svg>
                    <Typography sx={{ color: "#3ddab4" }}>
                        Application Submitted
                    </Typography>
                </Grid>

            );
        }

        if (clinicianStatus === "Hired" && offerStatus === "No Offer") {
            return (

                <Button
                    variant="contained"
                    sx={{ backgroundColor: "#6ebe44", mt: 2 }}
                    type="submit"
                    onClick={() => checkStatus("Hired")}
                >
                    View Offer
                </Button>
            );
        }

        if (clinicianStatus === "Hired" && offerStatus === "OfferAccepted") {
            return (

                <Grid>
                    <div className="dflex">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="25"
                            height="25"
                            viewBox="0 0 48 48"
                        >
                            <circle cx="24" cy="24" r="20" fill="#3ddab4"></circle>
                            <polygon
                                fill="#c1f5ea"
                                points="39.091,17.515 35.015,13.604 22.775,26.233 16.679,20.433 12.768,24.509 18.843,30.289 22.92,34.179 26.86,30.119"
                            ></polygon>
                            <polygon
                                fill="#fff"
                                points="22.926,34.173 26.86,30.119 22.775,26.233 18.843,30.289"
                            ></polygon>
                        </svg>
                        <Typography sx={{ color: "#3ddab4" }}>
                            Offer Accepted
                        </Typography>
                    </div>
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: "#6ebe44", mt: 2 }}
                        type="submit"
                        onClick={() => checkStatus("Hired")}
                    >
                        View Offer
                    </Button>
                    {/* Add Timesheet button (if Service Date cross condition should be checked here) */}
                    {/* <Button
                        variant="contained"
                        sx={{ backgroundColor: "#6ebe44", mt: 2 }}
                    >
                        Add Timesheet
                    </Button> */}
                </Grid>

            );
        }

        if (clinicianStatus === "Under Review") {
            return (

                <Typography sx={{ color: "#34c5a2" }}>
                    Your Application is Under Review
                </Typography>
            );
        }

        if (clinicianStatus === "Rejected Offer" || offerStatus === "Reject Offer") {
            return (

                <Typography sx={{ color: "#f91a1a" }}>Offer Rejected</Typography>

            );
        }

        return null;
    };

    return <>{renderContent()}</>;
};

export default RenderStatusJobCard;
